import { sendEmailVerification } from "firebase/auth";
import { useState } from "react";
import { useAuth } from "../../../firebase/AuthProvider";
import { Link } from "react-router-dom"; // Import Link for navigation

const VerifyEmailPage = () => {
  const { currentUser, logout } = useAuth();
  const [sent, setSent] = useState(false);

  const send = async () => {
    if (!currentUser) return;
    try {
      await sendEmailVerification(currentUser);
      setSent(true);
    } catch (error) {
      console.error("Error sending verification email:", error);
      // Optionally display an error message to the user
    }
  };

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center py-12 px-4 sm:px-6 lg:px-8">
      <div className="max-w-md w-full space-y-8 bg-white p-8 rounded-lg shadow-md">
        <div>
          <h1 className="text-2xl font-bold text-gray-900 text-center">
            Verify Your Email
          </h1>
          <p className="mt-2 text-sm text-gray-600 text-center">
            We've sent a verification link to{' '}
            <b className="font-semibold">{currentUser?.email}</b>. Click it, then
            sign in again.
          </p>
        </div>

        <div className="mt-6 space-y-4">
          {!sent && (
            <button
              onClick={send}
              className="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Resend Email
            </button>
          )}
          <Link
            to="/login" // Assuming your sign-in route is '/login'
            onClick={logout}
            className="w-full flex justify-center py-2 px-4 border border-gray-300 rounded-md shadow-sm text-sm font-medium text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Back to Sign-in
          </Link>
        </div>
      </div>
    </div>
  );
};

export default VerifyEmailPage;